
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iniciar-sesion",
      function () {
        return require("private-next-pages/iniciar-sesion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iniciar-sesion"])
      });
    }
  